// extracted by mini-css-extract-plugin
export default {"product-pic-top-brandPic":"bbMC6_product-pic-top-brandPic"};